import React, {Component} from "react";
import * as PropTypes from "prop-types";
import FormatMessage from "../../messages/FormatMessage";

export class EQ_Button_Navigation extends Component {
    static propTypes = {
        hasBack: PropTypes.bool,
        navNext: PropTypes.func,
        navPrevious: PropTypes.func
    }

    static defaultProps = {
        hasBack: true,
        navNext: () => {
        },
        navPrevious: () => {
        }
    }

    constructor(props) {
        super(props);
        this.handleNext = this.handleNext.bind(this);
    }

    handleNext() {
        const element = document.getElementById("navNext");
        this.props.navNext(element);
    }

    render() {
        const {hasBack, navNext, navPrevious} = this.props;
        return (
            <div className="EqBottomNav">
                <div className="FixedLayout EqBottomNav-fixedLayout">
                    {hasBack &&
                    <div className="FixedLayoutAside EqBottomNav-aside">
                        <a className="Button Button-eqSecondary EqBottomNav-backButton" onClick={navPrevious}>
                            <div className="FixedLayout Button-layout">
                                <div className="FixedLayoutAside Button-leftAside">
                                    <span className="Icon Button-icon Icon-chevronLeftAligned"></span>
                                </div>
                                <div className="FixedLayoutMain Button-label">
                                    <FormatMessage id="control.button.back"/>
                                </div>
                            </div>
                        </a>
                    </div>
                    }
                    {!hasBack &&
                    <div className="FixedLayoutAside EqBottomNav-aside"></div>
                    }
                    <div className="FixedLayoutMain EqBottomNav-main">
                        <a id="navNext" className="Button Button-eqPrimary EqBottomNav-button" onClick={(e) => this.handleNext()}>
                            <div className="FixedLayout Button-layout">
                                <div className="FixedLayoutMain Button-label">
                                    <FormatMessage id="control.button.continue"/>
                                </div>
                                <div className="FixedLayoutAside Button-rightAside">
                                    <span className="Icon Icon-chevronRightAligned Button-icon"></span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}

export default EQ_Button_Navigation;
